define(function(require, exports, module) {
    'use strict';

    var Class = require('Class');
    var AnimationManager = require('managers/animation.manager');

    module.exports = Class.create(AnimationManager, {

        _configTemplate: {
            animationEnabled: false,
            animationsMap: {
                // menu slider
                'menu__navigation': ['slideLineMenu'],
            },
            gamesinfoComingUp: false,
            gamesinfoRearrange: false
        }
    });
});
